module.exports = __webpack_public_path__ + "static/img/111.014ffaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/111.png
// module id = NKFV
// module chunks = 0